import { format, parseISO, set } from 'date-fns'

export const formatDate = (date: Date | string, withoutTimeReset = true): string => {
  let dateObj = typeof date === 'string' ? parseISO(date) : date
  if (!withoutTimeReset) dateObj = set(dateObj, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 })
  return format(dateObj, "yyyy-MM-dd'T'HH:mm:ssXXX")
}
